import { Action } from 'redux';
import { CheckoutActions, CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { put } from '@redux-saga/core/effects';
import { ErrorAction, AppState } from '../../root.types';
import { select } from 'redux-saga/effects';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface UpdateDeliveryDetailsContactOptionsAction extends Action<CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS> {
    contactOption: ContactOptionPayload;
}

export interface UpdateDeliveryDetailsContactOptionsActionStart extends Action<CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_START> {
    contactOption: ContactOptionPayload;
}

export interface UpdateDeliveryDetailsContactOptionsActionSuccess extends Action<CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_SUCCESS> {
}

export interface UpdateDeliveryDetailsContactOptionsActionError extends ErrorAction<CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_ERROR> {
}

export const updateDeliveryDetailsContactOptions: (contactOption: ContactOptionPayload) => UpdateDeliveryDetailsContactOptionsAction = (contactOption: ContactOptionPayload) => ({
    type: CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS,
    contactOption
});
updateDeliveryDetailsContactOptions[ACTION_CREATOR_NAME] = 'updateDeliveryDetailsContactOptions';

export type UpdateDeliveryDetailsContactOptionsFunc = (...args: Parameters<typeof updateDeliveryDetailsContactOptions>) => void;

export function* updateDeliveryDetailsContactOptionsSaga({ contactOption }: UpdateDeliveryDetailsContactOptionsAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_START,
        contactOption
    });

    try {
        let state: AppState = yield select();
        let customerId = state.basketState.basket!.session.userId;

        yield api.custex.updateCustomerDetailsContactOptions(customerId, contactOption.type, contactOption.isAllowed);

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_ERROR,
            error: errorToBasketErrorModel(error, 'updateDeliveryDetailsContactOptionsSaga')
        });

        return false;
    }
}

export type ContactOptionPayload = { type: 'email' | 'phone'; isAllowed: boolean };

